import React from 'react';
import { Title } from '@routific/hive';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { RouteDtoModelType } from '../../../../store/mst/models';
import RouteTitleWithPendingChanges from '../../RouteTitleWithPendingChanges';

interface Props {
  route: RouteDtoModelType
}

const TitleText = styled(Title)`
  && {
    margin: 0;
  }
`;

const RouteDetailsPanelHeader: React.FC<Props> = ({ route }) => (
  <RouteTitleWithPendingChanges
    title={(
      <TitleText level={4} ellipsis={{ tooltip: route.name || ' ' }}>
        {route.name || ' '}
      </TitleText>
    )}
    showPendingChanges={route.hasPublishablePendingChanges}
  />
);

export default observer(RouteDetailsPanelHeader);
